import React from 'react';
import { motion } from 'framer-motion';
import { UpgradeModal } from './UpgradeModal';
import { CHAT_PRODUCT_ID } from '../../utils/billing';
import { ANIMAL_ICONS } from '../../theme';

const ROOMS = [
  ['dragon', 'Empire', '#E4A62A', 'Where every pillar meets as one empire.', 'Rule the room, lead the voice.'],
  ['fashion', 'Fashion', '#D4AF37', 'Trade looks, drops and style secrets live.', 'Dress like you already won.'],
  ['food', 'Food', '#C8A95E', 'Share dishes, cafés and flavours from everywhere.', 'Taste the world together.'],
  ['explore', 'Explore', '#0F52BA', 'Swap routes, places and travel stories.', 'Every horizon is yours.'],
  ['souls', 'Soul', '#DC143C', 'Speak heart to heart, love, faith and healing.', 'Hearts rise together.'],
  ['sporty', 'Sport', '#10B981', 'Hype workouts, games and personal records.', 'Stronger every hour.'],
  ['success', 'Success', '#E5C44D', 'Celebrate wins, careers and big goals.', 'Winners talk to winners.'],
  ['legacy', 'Legacy', '#8B5CF6', 'Family, roots and the mark you leave.', 'Build what outlives you.'],
  ['art', 'Art', '#2A9BD8', 'Show your craft, music, design and ideas.', 'Create out loud.'],
];

const RoomSlide = ({ id, label, c, how, motto }) => {
  const ic = ANIMAL_ICONS[id] || ANIMAL_ICONS.dragon;
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-5"
      style={{ background: `radial-gradient(ellipse at 50% 30%, ${c}3D, transparent 65%)` }}>
      <motion.span className="rounded-full overflow-hidden block mb-3" style={{ width: 84, height: 84, border: `2px solid ${c}` }}
        initial={{ scale: 0.6 }} animate={{ scale: 1, boxShadow: [`0 0 10px ${c}66`, `0 0 30px ${c}`, `0 0 10px ${c}66`] }}
        transition={{ scale: { type: 'spring', stiffness: 200, damping: 14 }, boxShadow: { duration: 2.4, repeat: Infinity } }}>
        <img src={ic.src} alt="" className="w-full h-full object-cover" style={{ objectPosition: ic.pos }}/>
      </motion.span>
      <p className="font-['Cinzel'] uppercase" style={{ fontSize: 17, letterSpacing: '0.24em', color: c, textShadow: `0 0 14px ${c}99` }}>{label} Hour</p>
      <p className="font-['Outfit'] text-white/75 mt-1.5 leading-snug" style={{ fontSize: 12.5 }}>{how}</p>
      <p className="font-['Outfit'] text-white/50 mt-1" style={{ fontSize: 10.5 }}>Live global chat · messages vanish when the hour ends</p>
      <p className="font-['Cormorant_Garamond'] italic mt-2" style={{ fontSize: 16, color: '#F5D97A' }}>“{motto}”</p>
    </div>
  );
};

const SLIDES = ROOMS.map(([id, label, c, how, motto]) => ({ id, name: label, accent: c, node: <RoomSlide id={id} label={label} c={c} how={how} motto={motto}/> }));

/* Global Bliss Chat subscription (bliss_global_chat_99): the 9 hourly rooms as premium slides. */
export const ChatUpgradeModal = ({ onClose }) => (
  <UpgradeModal onClose={onClose} productId={CHAT_PRODUCT_ID} fallbackPrice="₹99" customSlides={SLIDES} testPrefix="chat-upgrade" title="Global Bliss Chat"
    headline={<><span style={{ color: '#F5D97A' }}>Join the live voice of the Empire.</span> A new icon room every hour and 10 chat coins a day, unlocked for 99.</>}/>
);

export default ChatUpgradeModal;
